import EmployeesService from './EmployeesService';

let instance;

export default function EmployeesServiceProvider() {
  if (!instance) {
    instance = new EmployeesService();
  }

  return instance;
}



// WEBPACK FOOTER //
// ./src/api/employees/EmployeesServiceProvider.js